/**
 * 专供生成所用
 **/
import { useMemo } from "react"
import { cn } from "@/utils"
import { PromptInput } from "#/promptInput"
import TextInput from "./text/TextInput"
import DropdownInput from "./Dropdown/DropdownInput"
import ContentChooserInput from "./contentChooser/ContentChooserInput"
import { Button } from "antd"
import { SquarePenIcon } from "lucide-react"

interface PromptInputsProps {
  inputOption: PromptInput
  onChange: (value: PromptInput['default']) => void
  value?: PromptInput['default']
  className?: string
}

// 提示词输入组件
export const PromptInputComponents = ({ inputOption, onChange, value, className }: PromptInputsProps) => {
  const selfValue = useMemo(() => {
    if (value) return value
    return inputOption.default
  }, [value, inputOption])

  const isContentChooser = useMemo(() => {
    return inputOption.types.includes('fullNovel')
      || inputOption.types.includes('codex')
      || inputOption.types.includes('act')
      || inputOption.types.includes('chapter')
      || inputOption.types.includes('scene')
      || inputOption.types.includes('snippet')
      || inputOption.types.includes('label')
  }, [inputOption])

  const handleChange = (value: PromptInput['default']) => {
    onChange(value)
  }

  return <>
    <div className="flex items-center gap-1">
      {inputOption.types.includes('dropdown') && !!inputOption.settings?.dropdown?.options?.length && <DropdownInput
        value={selfValue}
        inputOption={inputOption}
        onChange={handleChange}
        className={inputOption.mode === 'single' ? (inputOption.settings?.dropdown?.options?.length > 5 ? 'flex-1' : '') : ''}
      />}
      {inputOption.types.includes('text') && <Button type="text" icon={<span><SquarePenIcon size={16} /></span>} />}
    </div>

    {isContentChooser && <ContentChooserInput
      value={selfValue}
      onChange={handleChange}
      inputOption={inputOption}
      triggerProps={{ type: 'text' }}
    />}
  </>
}